import script from "./AdministratorRequestForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorRequestForm.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorRequestForm.vue?vue&type=style&index=0&id=6f3dbd4b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f3dbd4b"]])

export default __exports__